module.exports = __webpack_public_path__ + "static/front-009-ca671d47b1325767cb30acb0bc496dff.png";